import * as React from 'react';

import 'react-activity-feed/dist/index.css';

export default class DropdownPanel extends React.Component {
  static defaultProps = {
    arrow: true,
    left: true,
    right: false,
  };

  render() {
    return (
      <div
        className={`raf-dropdown-panel ${this.props.arrow ? ' raf-dropdown-panel--arrow' : ''} ${
          this.props.right
            ? ' raf-dropdown-panel--right raf-dropdown-panel--arrow-right'
            : 'raf-dropdown-panel--left raf-dropdown-panel--arrow-left'
        }`}
      >
        <div className='raf-dropdown-panel__header'>{this.props.Header}</div>
        <div className='raf-dropdown-panel__content'>{this.props.children}</div>
        {this.props.Footer != null && <div className='raf-dropdown-panel__footer'>{this.props.Footer}</div>}
      </div>
    );
  }
}
